export enum SupportPeriodType {
    Undefined = 0,
    Permanent = 1,
    Hours1 = 2,
    Hours2 = 3,
    Hours4 = 4,
    Hours8 = 5,
    Days1 = 6,
    Days2 = 7
}
